import React,{useState,useEffect} from 'react';
import Layout from '../../layout';
import {css} from 'emotion';
import Input from '../../common/material-easy-ui/input/Input';
import InputDate from '../../common/material-easy-ui/input/InputDate';

import {useSelector,useDispatch} from 'react-redux';
import ModalValidation from '../components/ModalValidation';
import ModalError from '../../common/modalError';
import ModalValid from '../../common/modal-valid';
import FormAPI from '../../../api/FormAPI';
import {formatDateSQL} from '../../../utils/dateOperation';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import history from '../../../utils/history'


const BoatForm = (props) =>{
  const dispatch = useDispatch();


  /*Date.prototype.toDateInputValue = (function() {
    console.log(this);
    var local = new Date(this);
    console.log(local);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    console.log(local);
    console.log(local.toJSON().slice(0,10));
    return local.toJSON().slice(0,10);
  });*/

  const info_user = useSelector(state=>state.user.info_user);

  const popkey = useSelector(state=>state.user.popkey);
  const [boat_immatriculation,set_boat_immatriculation] = useState(info_user.boat_immatriculation);
  const [boat_name,set_boat_name] = useState(info_user.boat_name);
  //const [date,setDate] = useState(new Date().toDateInputValue());
  const [date,setDate] = useState(new Date());
  const [time,setTime] = useState(0);
  const [port,setPort] = useState('');
  const [adress,setAdress] = useState(info_user.adress_postal);
  const [showModalValidation,setShowModalValidation] = useState(false);

  //erreur

  const [error_date,setError_date] = useState(false);
  const [error_port,setError_port] = useState(false);
  const [error_time,setError_time] = useState(false);
  const [error_adress,setError_adress] = useState('');
  const [error_boatName,setError_boatName] = useState(false);
  const [error_boatImmatriculation,setError_boatImmatriculation] = useState(false);
  const [showErrorModal,setShowErrorModal] = useState(false);
  const [valid_form_boat,setValidFormBoat] = useState(false);
  const [loader,setLoader] = useState(false);

  /*useEffect(()=> {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    var newdate = local.toJSON().slice(0,10);
  },[date])*/


  const chooseTime = (time) => setTime(time)

  const onShowModalValidation = () =>{
    setError_date(false);
    setError_port(false);
    setError_time(false);
    setError_boatName(false);
    setError_adress(false);
    setError_boatImmatriculation(false);


    if(date == ''){
      setError_date({error:true,message:'Il y a une erreur lors de votre saisie'})
    }
    if(adress == ''){
      setError_adress({error:true,message:'Il ya une erreur lors de votre saisire'});
      window.scrollTo(0,0);
    }
    if(boat_immatriculation == ''){
      setError_boatImmatriculation({error:true,message:'Il y a une erreur lors de votre saisie'});
      window.scrollTo(0,0);
    }
    if(boat_name == ''){
      setError_boatName({error:true,message:'Il y a une erreur lors de votre saisie'});
        window.scrollTo(0,0);
    }
    if(time == 0 || time ==''){
      setError_time({error:true,message:'Vous devez ajouter votre durée'});
      window.scrollTo(0,document.body.scrollHeight);
    }
    if(port == ''){
      setError_port({error:true,message:'Il y a une erreur lors de votre saisie'});
      window.scrollTo(0,document.body.scrollHeight);
    }

    if(date != '' && adress != '' && boat_immatriculation != '' && boat_name != '' && (time != 0 || time !='') && port !=''){
        setShowModalValidation(true);
    }

  }

  const onValid = (e) =>{
    // ENVOYER INFORMATION PAR L API
    setLoader(true);

    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    var newdate = local.toJSON().slice(0,10);

    FormAPI.sendInformationLocation(popkey,boat_immatriculation,boat_name,newdate,time,port,adress)
    .then((data)=>{
      dispatch({type:'SET_INFO_ADRESS_USER',payload:{adress_postal:data.data.adress_postal}});
        if(data.data.hasOwnProperty('boat')){
          dispatch({type:'SET_INFO_BOAT_USER',payload:{
            boat_immatriculation:data.data.boat.boat_immatriculation,
            boat_name:data.data.boat.boat_name,
            id_boat:data.data.boat_id_boat,
          }})
          setLoader(false)
        }
        setShowModalValidation(false);
        setValidFormBoat(true);
    })
    .catch((error)=>{
      setLoader(false);
      setShowModalValidation(false)
      setShowErrorModal(error.response.data.status)
    });


  }


  const onCloseModalError = () =>{
    setShowErrorModal(false)
  }

  const onCloseBox = () =>{
    setShowModalValidation(false)
  }

  const onCloseValidFormBoat = () =>{
    history.push({pathname:'/vos-déclarations'})
    setValidFormBoat(false);
  }


  return(
    <Layout location={props.location}>
      <div className={css`max-width:678px;margin:0 auto;`}>
      <div className={css`background-color:white;box-sizing:border-box;padding:20px;margin-top:10px`}>
        <div className={css`color:#3f4d6e;font-weight:600`}>FORMULAIRE DE LOCATION DE NAVIRE</div>
        <div className={css`margin-top:20px;color:#8b92a3;font-style:italic`}>Bienvenue dans la section location ponctuelle de navire à moteur! Vous êtes
              propriétaire de votre navire et vous souhaitez le louer pour un usage en
              cœur de Parc national des Calanques, merci de compléter les informations
              suivantes, relatives à la location. Chaque location à destination du cœur de
              Parc doit faire l'objet d'une nouvelle demande d'autorisation. Pour
              information la délibération CA 2019-12.17 défini un nombre maximal de cinq
              locations par année civile.
          </div>

        <div className={css`margin-top:40px`}>
        <div className={css`color:grey`}>Informations du proprietaire du navire</div>
        <Input
          error={error_adress}
          onChangeText={(e)=>{setAdress(e.target.value)}}
          text={adress}
          placeholder='Adresse postale'
          label='Adresse postale'
           type={'text'}
           style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
           inputStyle={{fontSize:15}}
           labelStyle={{color:'#cccccc'}}/>
        </div>

        <div className={css`margin-top:40px`}>
        <div className={css`color:grey`}>*Informations du navire</div>

        <Input
          error={error_boatImmatriculation}
          onChangeText={(e)=>{set_boat_immatriculation(e.target.value)}}
          text={info_user.boat_immatriculation}
          placeholder='Immatriculation du navire'
          label='Immatriculation du navire'
          disabled={info_user.boat_immatriculation?true:false}
           type={'text'}
           style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
           inputStyle={{fontSize:15}}
           labelStyle={{color:'#cccccc'}}/>
           <Input
              error={error_boatName}
              onChangeText={(e)=>{set_boat_name(e.target.value)}}
              text={info_user.boat_name}
              disabled={info_user.boat_name?true:false}
              placeholder='Nom du navire'
              label='Nom du navire'
              type={'text'}
              style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
              inputStyle={{fontSize:15}}
              labelStyle={{color:'#cccccc'}}/>
        </div>

          <div className={css`font-size:12px;font-style:italic;color:grey;margin-top:10px;color:#0085C6`}>*Pour modifier les informations de votre navire veuillez les changer dans votre profil</div>




          <div className={css`margin-top:40px`}>
          <div className={css`color:grey`}>Date de la location</div>
          {/*<Input
            error={error_date}
             onChangeText={(e)=>{setDate(e.target.value)}}
             text={date}
             label="Date de la location"
             type={'date'}
             style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
             inputStyle={{fontSize:15}}
             labelStyle={{color:'#cccccc'}}/>
           */}

          <InputDate
              labelStyle={{color:'#cccccc'}}
              label="Date de la location"
              style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
              date={date}
              onChange={(date)=>{setDate(date)}}
              error={error_date}
          />

          </div>


          <div className={css`margin-top:40px`}>
          <div className={css`color:grey`}>Durée de la location</div>
            <div className={css`margin-top:20px;display:flex`}>
              <div onClick={(e)=>{chooseTime(0.5)}} className={css`&:hover{background-color:#5c9ebf};cursor:pointer;flex:1;background-color:#0085C6;height:40px;text-align:center;color:white;border-radius:10px;line-height:40px`}>1/2 Journée</div>
              <div onClick={(e)=>{chooseTime(1)}} className={css`&:hover{background-color:#5c9ebf};cursor:pointer;flex:1;background-color:#0085C6;height:40px;text-align:center;margin-left:40px;color:white;border-radius:10px;line-height:40px`}>1 Journée</div>
            </div>
            <Input
               error={error_time}
               text={time >= 0 ? time : 0}
               onChangeText={(e)=>chooseTime(e.target.value)}
               min="0"
               placeholder="Autre durée"
               label='Jours'
               type={'number'}
               style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
               inputStyle={{fontSize:15}}
               labelStyle={{color:'#cccccc'}}/>
          </div>



          <div className={css`margin-top:40px`}>
          <div className={css`color:grey`}>Port de départ</div>
          <Input
             error={error_port}
             onChangeText={(e)=>{setPort(e.target.value)}}
             label='Port de départ'
             type={'text'}
             style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
             inputStyle={{fontSize:15}}
             labelStyle={{color:'#cccccc'}}/>
          </div>

          <div onClick={onShowModalValidation} className={css`&:hover{background-color:#5c9ebf};cursor:pointer;background-color:#0085C6;color:white;height:50px;line-height:50px;border-radius:10px;text-align:center;margin-top:40px`}>Envoyer</div>
      </div>

      </div>
      {showModalValidation && <ModalValidation loader={loader} onCloseBox={onCloseBox} onValid={onValid}/>}
      {showErrorModal && <ModalError message={showErrorModal} onClose={onCloseModalError}/>}
      { valid_form_boat && <ModalValid message={"Votre demande est envoyé.\nVous allez recevoir un email."} onClose={onCloseValidFormBoat}/>}
    </Layout>
  )
}

export default BoatForm
